import * as React from 'react';
import { connect } from 'react-redux';

import { IncorrectSequencesContainer, IncorrectSequence } from '../../../Shared/index';
import * as questionActions from '../../actions/questions';

interface StateProps {
  incorrectSequences: { [key: string]: IncorrectSequence };
}

interface OwnProps {
  match: {
    params: {
      questionID: string;
    };
  };
}

type Props = StateProps & OwnProps & { dispatch: any };

const GrammarIncorrectSequenceContainer: React.FC<Props> = ({ incorrectSequences, match, dispatch }) => {
  const { questionID } = match.params;
  const baseUrl = `/grammar/#/admin/questions/${questionID}/incorrect-sequences`;

  const handleUpdateSequences = (questionID: string, sequences: { [key: string]: IncorrectSequence }, callback?: () => void) => {
    dispatch(questionActions.updateIncorrectSequences(questionID, sequences, callback));
  };

  const handleDeleteSequence = (questionID: string, sequenceID: string) => {
    dispatch(questionActions.deleteIncorrectSequence(questionID, sequenceID));
  };

  const handleSubmitEditedSequence = (questionID: string, data: IncorrectSequence, key: string) => {
    dispatch(questionActions.submitEditedIncorrectSequence(questionID, data, key));
  };

  const handleMount = (questionID: string) => {
    dispatch(questionActions.getUsedSequences(questionID));
  };

  return (
    <IncorrectSequencesContainer
      baseUrl={baseUrl}
      incorrectSequences={incorrectSequences}
      onDeleteSequence={handleDeleteSequence}
      onMount={handleMount}
      onSubmitEditedSequence={handleSubmitEditedSequence}
      onUpdateSequences={handleUpdateSequences}
      questionID={questionID}
    />
  );
};

function select(state: any, ownProps: OwnProps): StateProps {
  const { questionID } = ownProps.match.params;
  const question = state.questions.data[questionID];

  return {
    incorrectSequences: question?.incorrectSequences || {},
  };
}

export default connect(select)(GrammarIncorrectSequenceContainer);
